import axios from 'axios';
import {getUserData} from './services/utilityServices';
import { APPVERSION } from './constants/generals';

const baseURL = 'https://server.spitraining.net';
//const baseURL = 'https://stagepy.spitraining.net';
// const baseURL = 'http://18.224.53.53';
// const baseURL = 'http://127.0.0.1:5000';


async function getUpgradeStatus(currVersion: string) {
    try {
        
        const currentVersion = parseInt(APPVERSION);
        const serverVersion = parseInt(currVersion);
        
        if (serverVersion > currentVersion) {
            if ('caches' in window) {
                const names = await caches.keys();
                await Promise.all(names.map(name => caches.delete(name)));
            }
            
            if ('serviceWorker' in navigator) {
                const registrations = await navigator.serviceWorker.getRegistrations();
                for (let registration of registrations) {
                    await registration.unregister();
                }
            }
            
            // Force reload the page from network
            window.location.reload();
            return;
        }
        return true;
    } catch (error) {
        console.log('Version check failed:', error);
        return true;
    }
}

export async function get(url: string, data: Object) {
    try {
        const axiosInstance = axios.create({
            baseURL,
            headers: {
                'Content-Type': 'application/json',
                Auth: (getUserData() || '').token,
            }
        });
        axiosInstance.defaults.timeout = 100000;
        const response = await axiosInstance.get(`${url}`, data);
        response.headers.expires && await getUpgradeStatus(response.headers.expires);

        if (response && response.data && (response.data.Status) && response.data.Status.toLowerCase() === 'valid' && JSON.stringify(response.data).indexOf('error') < 0) {
            return response.data;
        } 
        else if (response && response.data && response.data.mfa_enforced !== undefined) {
            return response.data;
        }
        else {
            throw response.data.Message ? response.data.Message : response.data.error;
        }
    } catch (error) {
        throw error;
    }
}

export async function del(url: string, data: Object) {
    const axiosInstance = axios.create({
        baseURL,
        headers: {
            'Content-Type': 'application/json',
            Auth: (getUserData() || '').token,
        }
    });
    try {
        const response = await axiosInstance.delete(url, {data: data});
        response.headers.expires && await getUpgradeStatus(response.headers.expires);
        if (response && response.data && (response.data.Status) && response.data.Status.toLowerCase() === 'valid' && JSON.stringify(response.data).indexOf('error') < 0) {
            return response.data;
        } else {
            throw response.data.Message ? response.data.Message : response.data.error;
        }
    } catch (error) {
        throw error;
    }
}

export async function put(url: string, data: Object) {
    const axiosInstance = axios.create({
        baseURL,
        headers: {
            'Content-Type': 'application/json',
            Auth: (getUserData() || '').token,
        }
    });
    try {
        const response = await axiosInstance.put(url, data);
        response.headers.expires && await getUpgradeStatus(response.headers.expires);
        if (response && response.data && (response.data.Status) && response.data.Status.toLowerCase() === 'valid' && JSON.stringify(response.data).indexOf('error') < 0) {
            return response.data;
        } 
        else if (response && response.data && response.data.success === true) {
            return response.data;
        }
        else {
            throw response.data.Message ? response.data.Message : response.data.error;
        }
    } catch (error) {
        throw error;
    }
}

export async function post(url: string, data: Object) {
    
    const axiosInstance = axios.create({
        baseURL,
        headers: {
            'Content-Type': 'application/json',
            Auth: (getUserData() || '').token,
        },
    });
    try {
        const response: any = await axiosInstance.post(url, data);
        
        response.headers.expires && await getUpgradeStatus(response.headers.expires);
        
        if (response && response.data && (response.data.Status) && response.data.Status.toLowerCase() === 'valid' && JSON.stringify(response.data).indexOf('error') < 0) {
            return response.data;
        } else if (response && response.data && response.data.success === true) {
            return response.data;
        } else {
            throw response.data.Message ? response.data.Message : response.data.error;
        }
   } catch (error) {
        throw error;
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/HTTP.ts